export default "__VITE_ASSET__D5q1P56I__"